import { classNames } from "../../../helpers";
import React from "react";
import { safe_get } from "../../../report-visuals";

export const VoterId = ({ id, hover, voterData }) => {
  const hasInteractions = safe_get(voterData, "interactions", null);
  const headOfTheFamily = safe_get(voterData, "hoh", false);
  return (
    <div
      className={classNames(
        "transition-all duration-[700ms] ease-in-out font-medium text-sm leading-3 text-center space-x-2 rounded-tr-3xl rounded-tl-3xl py-[16px]",
        hover ? "bg-black" : "bg-white",
      )}
    >
      <div className="flex items-center justify-center gap-2">
        {hasInteractions && (
          <img
            src={"/img/Frame.svg"}
            alt={"frame"}
            className="w-6 h-6 transition-all duration-[700ms] ease-in-out"
          />
        )}
        {headOfTheFamily ? (
          <i className={"fa-solid fa-crown text-yellow-300 text-xl"} />
        ) : null}
        <span
          className={classNames(
            "transition-all duration-[700ms] ease-in-out",
            hover ? "text-[#A1A1A1]" : "text-[#848484]",
          )}
        >
          Voter Id
        </span>
        <span
          className={classNames(
            "transition-all duration-[700ms] ease-in-out",
            hover ? "text-white" : "text-[#1B1B1D]",
          )}
        >
          {id}
        </span>
      </div>
    </div>
  );
};
